export const billing = {
  menuLabel: 'Billing Tool',
  text: 'Billing Tool - Client Insurers search',
  error: 'Unable to load Billing Tool',
};
